import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import components from './plugins/components'
import directives from './directives'
import motify from 'motify'
import 'motify/motify.css'
import './style/common.scss'
import { globalClient } from './utils/client'
import { client } from 'myoa-lib-js'

Vue.config.productionTip = false
Vue.use(motify)
Vue.use(components, { vuetify })
Vue.use(directives)
window.$router = router

router.beforeEach(async (to, from, next) => {

  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  store.dispatch("changeFontSize", store.state.fontSize);

  if (!window.top.client) {
    console.log('等待client加载--------')
    let _client = await client.getClient()
    console.log('client加载结束--------')
    if (_client === null) {
      _client = globalClient
    }

    window.top.client = _client
  }

  window.top.myoa_client = window.top.client

  // 判断登录用户为职防院跳转
  if (window.top.client.closeApp) {
    const userInfo = await window.top.client.loadUserInfo()
    let { id, name } = userInfo.current.organization
    if (id === 'eedd85bd-6fb5-4089-aa2c-f76efec480f4' || id === 'e547738a-2c77-4c3a-b0cf-4300f7014975' || name === '茂名市职业防治院') {
      window.location.href = 'https://myoa.mmzqoa.net/web/myoa-new-web/index.html#/docmain/pending'
    }
  }

  next()
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
